import { Component, Injector, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { JackBaseComponentModule, MaterialModule, PageKind, UiModeType, } from 'jk-service';
import { UtysaService, templateUrlConfigUty } from '../_service_uty';
import { UtysaEditComponent, } from '../_edit_uty';
import { jkSingleComponent, AdvComModule } from 'jk-advcom';



@Component({
  selector: 'app-utypi02-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './utypi02-detailPkg.component.html',//templateUrlConfigUty.utypi02_detail,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utypi02DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'utypi02-detail';
  constructor() {
    super();
    this.srv = new UtysaService();
    this.pageKind = PageKind.detail;
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'SA001=MainTable,SA002=ITEM';
    this.masterEditPage = UtysaEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'SA003', sort: 'asc', defaultSort: null, pageKind: this.pageKind };

    //this.constructorInit(); // ###

  }
  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    this.srv.cdr = this.cdr;
  };


}
